module.exports = "<input class=\"form-control\" id=\"role-selector\" type=\"checkbox\" \n    (click)=\"setAdmin()\" [checked]=\"isAdmin()\" [disabled]=\"disabled\"/> <label for=\"role-selector\">Is Admin</label>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/role-selector/role-selector.component.html
// module id = ./src/app/shared/role-selector/role-selector.component.html
// module chunks = main